<app-breadcrumb *ngIf="!dialogRef && !document" [master]="masterModule ? masterModule : 'Struktura sieci'" parentName="Dokumenty" name="Dodaj"></app-breadcrumb>
<div class="document-add" fxLayout="column" fxLayoutGap="15px" [formGroup]="documentForm">
  <div *ngIf="!dialogRef" fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!documentForm.valid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button  *ngIf="!dialogRef && !documentObject" (click)="save(true)" [class.spinner]="processingRequest"
            [disabled]="!documentForm.valid"
            mat-stroked-button color="accent"><mat-icon>save</mat-icon> <span> Zapisz i dodaj kolejne </span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" [fxFlex]="dialogRef ? '100' : '50'" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Dane pliku</h3>
            </div>
            <div fxLayout="row">

              <app-file-drag-and-drop fxFlex="100" [multiple]="false" [fileControl]="fileControl"  ></app-file-drag-and-drop>


<!--              <mat-form-field fxFlex="100">-->
<!--                <ngx-mat-file-input-->
<!--                  placeholder="Wybierz plik ({{fileMaxSize | byteFormat}})"-->
<!--                  [required]="!document"-->
<!--                  [multiple]="true"-->
<!--                  formControlName="file"-->
<!--                ></ngx-mat-file-input>-->
<!--                <mat-icon matSuffix color="accent">attachment</mat-icon>-->
<!--                <mat-error *ngIf="documentForm.get('file').hasError('required')">Wybierz plik</mat-error>-->
<!--                <mat-error *ngIf="documentForm.get('file').hasError('maxContentSize')">-->
<!--                  Całkowity rozmiar pliku nie może przekraczać-->
<!--                  {{documentForm.get('file').getError('maxContentSize').maxSize | byteFormat}}-->
<!--                  (Wybrany plik: {{documentForm.get('file').getError('maxContentSize').actualSize-->
<!--                  | byteFormat}}).-->
<!--                </mat-error>-->
<!--              </mat-form-field>-->
            </div>

            <div fxLayout="row" *ngIf="documentObject">
              <mat-form-field fxFlex="100">
                <mat-label>Nazwa dokumentu</mat-label>
                <input matInput placeholder="Umowa Jan Kowalski" formControlName="documentName" [required]="false">
              </mat-form-field>
            </div>

            <div fxLayout="row" *ngIf="allowedTypes ? allowedTypes?.includes('FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM') : true">
              <app-dict
                fxFlex="100" dictType="file_type" label="Typ dokumentu"
                [required]="true" [control]="documentTypeControl"
                [onlyKeys]="allowedTypes ? allowedTypes : null"
                [skipKeys]="skipKeys"
              ></app-dict>
            </div>

            <div fxLayout="row" *ngIf="allowedTypes ?  !allowedTypes?.includes('FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM'): false">
              <app-dict
                fxFlex="100" dictType="file_type" label="Typ dokumentu"
                [required]="true" [control]="documentTypeControl"
                [onlyKeys]="allowedTypes"
              ></app-dict>
            </div>

            <div fxLayout="row" *ngIf="deviceObject || this.documentObject?.deviceProtocolDate">
              <div fxFlex="100">
                <app-datepicker
                  label="Data przekazania/zwrotu"
                  placeholder="2000-01-01"
                  [required]="true"
                  [control]="deviceProtocolDateControl"
                ></app-datepicker>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireDocumentInformation">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Informacje o dokumencie</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-slide-toggle fxFlex="33" [formControl]="documentInformationScanControl" color="accent">Skan</mat-slide-toggle>
                <mat-slide-toggle fxFlex="33" [formControl]="documentInformationOriginalControl" color="accent">Oryginał</mat-slide-toggle>
                <mat-slide-toggle fxFlex="33" [formControl]="documentInformationDocumentMissingControl" color="accent">Brak dokumentu</mat-slide-toggle>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireInsuranceCompany && dialogRef">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>TU</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict-insurance-companies fxFlex="100" label="TU" [disable]="!!registrationObject"
                [control]="insuranceCompanyControl" [required]="true" [onlyKeys]="insuranceCompanyKeys" (selectedInsuranceCompany)="onInsuranceCompanySelected($event)"></app-dict-insurance-companies>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="cert40p100p && hasInsuranceCompanyMessage() || cert40p100p && certDateRequired">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Honorowanie zaświadczeń</h3>
            </div>

            <div fxLayout="row" *ngIf="certDateRequired">
              <div fxFlex="100">
                <app-datepicker
                  label="Data wystawienia zaświadczenia"
                  placeholder="2000-01-01"
                  [required]="true"
                  [control]="certDateControl"
                ></app-datepicker>
                <div fxLayout="row" *ngIf="documentForm.get('certDate').hasError('invalidDate')" style="color:red;">
                  Wskazana data nie jest honorowana.
                </div>
              </div>
            </div>

            <div
              fxLayout="row"
              fxFlex.lt-md="100%"
              *ngIf="cert40p100p && hasInsuranceCompanyMessage() || cert40p100p && hasInsuranceCompanyMessage() && !dialogRef">
              <div fxFlex="100">
                  <p style="color:red;">
                    {{
                      INSURANCE_COMPANY_MESSAGES[selectedInsuranceCompany?.key] ||
                      INSURANCE_COMPANY_MESSAGES[registrationObject?.insuranceCompany?.key]
                    }}
                  </p>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireContractOfwca && ofwcaControl.value && dialogRef" >
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Umowa</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict-contracts fxFlex="100" label="Umowa"   [control]="contractControl" [required]="true" [contracts]="ofwcaContracts"
                                    [showOwnerName]="true" [showStatus]="true"></app-dict-contracts>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" *ngIf="!dialogRef">

      <app-contract-select-card #contractSelectCardComponent [control]="contractControl" *ngIf="requireContract"></app-contract-select-card>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireOfwca">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>OFWCA</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict-ofwcas fxFlex="100" label="OFWCA"
                                 [control]="ofwcaControl" [required]="true"
                                 (selectedOfwca)="selectedOfwca = $event"
                ></app-dict-ofwcas>
              </div>
            </div>

          </mat-card>
        </div>
      </div>



      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireContractOfwca && ofwcaControl.value" >
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Umowa</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict-contracts fxFlex="100" label="Umowa"   [control]="contractControl" [required]="true" [contracts]="ofwcaContracts"
                                    [showOwnerName]="true" [showStatus]="true"></app-dict-contracts>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requirePartner">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Partner</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict-partners fxFlex="100" label="Partner"
                                 [control]="partnerControl" [required]="true"></app-dict-partners>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireKrk">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>KRK</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict-krk  fxFlex="100" label="KRK"
                                   [control]="krkControl"
                               [filterOfwcaKRK]="selectedOfwca"
                               [required]="true"
                ></app-dict-krk>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireInsuranceCompany">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>TU</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict-insurance-companies fxFlex="100" label="TU"
                  [control]="insuranceCompanyControl" [required]="true" [onlyKeys]="insuranceCompanyKeys"
                  (selectedInsuranceCompany)="selectedInsuranceCompany = $event"
                ></app-dict-insurance-companies>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="((requireRegistration && !requireInsuranceCompany && pzuCondition) || (requireInsuranceCompany && requireInsuranceCompany && selectedInsuranceCompany && pzuCondition) && !isAmlCertificate)">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Rejestracja</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict-registrations   fxFlex="100" label="Rejestracja"
                  [control]="registrationControl" [required]="true" [status]="true" [company]="true"
                  [filterInsuranceCompany]="selectedInsuranceCompany"
                  [filterOfwca]="selectedOfwca"
                ></app-dict-registrations>
              </div>
            </div>

          </mat-card>
        </div>
      </div>


      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireComments">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Uwagi</mat-label>
                  <input [required]="false" matInput placeholder="Uwagi" [formControl]="commentsControl" >
                </mat-form-field>
              </div>
            </div>



          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireCurrentEntityOfRegistration">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Aktualny podmiot rejestracji</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Aktualny podmiot rejestracji</mat-label>
                  <input [required]="false" matInput placeholder="Aktualny podmiot rejestracji" [formControl]="currentEntityOfRegistrationControl" >
                </mat-form-field>
              </div>
            </div>



          </mat-card>
        </div>
      </div>

    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" >
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!documentForm.valid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button  *ngIf="!dialogRef && !documentObject" (click)="save(true)" [class.spinner]="processingRequest"
            [disabled]="!documentForm.valid"
            mat-stroked-button color="accent"><mat-icon>save</mat-icon> <span> Zapisz i dodaj kolejne </span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
